var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49899 7.93939L8.43924 5.99914L12.1892 9.74914L10.249 11.6894L6.49899 7.93939ZM22.5602 17.9991L9.49974 4.93864C8.93274 4.37164 7.94349 4.37239 7.37874 4.93864L5.43924 6.87814C4.85424 7.46239 4.85424 8.41414 5.43924 8.99914L18.499 22.0596C18.7915 22.3521 19.1755 22.4984 19.5595 22.4984C19.9435 22.4984 20.3275 22.3521 20.62 22.0604L22.5602 20.1201C22.8437 19.8374 22.9997 19.4601 22.9997 19.0596C22.9997 18.6591 22.8437 18.2826 22.5602 17.9991Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98997 2.99977L3.48975 1.5L4.98952 2.99977L3.48975 4.49955L1.98997 2.99977Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98997 11.9998L3.48975 10.5L4.98952 11.9998L3.48975 13.4995L1.98997 11.9998Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.99 2.99977L12.4897 1.5L13.9895 2.99977L12.4897 4.49955L10.99 2.99977Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.ae351201f684a1d4e54ba889794e9091.svg";
export { ForwardRef as ReactComponent };